export default __webpack_public_path__ + "static/media/trocar.6d9d12f7.png";